import React from "react"
import {initReactQueryAuth} from 'react-query-auth'
import {LoadingSpinner} from '../components'
import { roles } from "../lib/roles"
import { login } from "./api/login"
import { storage } from "../helpers"
import { getUser } from "./api/getUser"



const handleError = ({errorResponse}) => {
  storage.clearToken()
  window.location.assign(window.location.origin)
}

async function handleUserResponse(data) {
  const {token = undefined, id, username, company, category, pointOfWork, roles: rolesArray} = data
  if (token) {
    storage.setToken(token)
  }
  const role= rolesArray[0]
  const isAdmin = role === roles.ROLE_ADMINISTRATOR
  const isManager = role === roles.ROLE_MANAGER
  const isController = role === roles.ROLE_CONTROLER
  const isOperational = role === roles.ROLE_OPERATIONAL
  const isGuest = role === roles.ROLE_GUEST

  const user = { id, username,role, company, category, pointOfWork, isAdmin, isManager, isController, isOperational, isGuest}

  return user
}

async function loadUser() {
  if(storage.getToken()) {
    const data = await getUser()
    const user = await handleUserResponse(data)
    return user
  }
}

async function loginFn(data) {
  const response = await login(data)
  const user = await handleUserResponse(response)
  return user
}

async function logoutFn(data) {
  window.location.assign(window.location.origin)
  storage.clearToken()
}

const authConfig = {
  loadUser,
  loginFn,
  logoutFn,
  LoaderComponent: () => {
    return <LoadingSpinner message="Aplicatia se incarca..." thickness="10" />
  },
  ErrorComponent: (error) => handleError(error)
}

export const {AuthProvider, useAuth} = initReactQueryAuth(authConfig)